// extracted by mini-css-extract-plugin
export default {"wrapper":"Kx-z","viewport":"Lx-z","container":"Mx-z","slide":"Nx-z"};